import React from 'react'
import logo from './images/logo.png'

export default class Header extends React.Component {
	render() {
		return <header className="Header">
			<img src={logo} />
			<p className="actions">
				<button className="switch-site" onClick={() => this.props.onSwitchSite()}>Switch Site</button>
				{this.props.user ?
					<button className="logout" onClick={() => this.props.onLogout()}>Log out</button>
				:
					<button className="login" onClick={() => this.props.onLogin()}>Log in</button>
				}
			</p>
		</header>
	}
}

Header.propTypes = {
	onLogin: React.PropTypes.func.isRequired,
	onLogout: React.PropTypes.func.isRequired,
	user: React.PropTypes.object,
}



/** WEBPACK FOOTER **
 ** ./src/Header.js
 **/